import { render as ReactDOMRender } from 'react-dom';
import React from 'react';

export function render(element, container, callback) {
    return ReactDOMRender(
        React.createElement(React.StrictMode, null, element),
        container,
        callback
    );
}
